import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=832ae41a&scoped=true&"
import script from "./UsersList.vue?vue&type=script&lang=ts&"
export * from "./UsersList.vue?vue&type=script&lang=ts&"
import style0 from "./UsersList.vue?vue&type=style&index=0&id=832ae41a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832ae41a",
  null
  
)

export default component.exports